/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import ManageBlogFaqs from "./ManageBlogFaqs.container";

export default ManageBlogFaqs;
